import Vue from 'vue';
import Vuex, { MutationTree, ActionTree, GetterTree } from 'vuex';

import { GradeState } from '../models/store-viewmodel';
import { Study, ModuleDetail, AcademicYear, TranscriptRequest } from '../models/grade-viewmodels';
import { root } from '@/shared/store/index';
import { Config } from '../models/config-viewmodel';

Vue.use(Vuex);

const state: GradeState = {
    studies: [],
    activeStudy: undefined,
    result: undefined,
    transcriptRequest: undefined,
    config: {
        language: '',
        vuNetIdStudent: '',
        vuNetIdUser: '',
        excurid: '',
        moduleSubscribeLink: ''
    }
}

const mutations: MutationTree<GradeState> = {
    setStudies(state, data: Study[]) {
        state.studies = data;
    },

    setCoursesByStudy(state, { values, year, studyId }) {
        state.studies.map((study: Study) => {
            if (study.id === studyId) {
                study.academicYears.map((academicYear: AcademicYear) => {
                    if (academicYear.year === year) {
                        academicYear.courses = values;
                    }

                    return academicYear;
                })
            }

            return study;
        });
    },

    setSelectedStudy(state, study: Study) {
        state.activeStudy = study;
    },

    setModuleDetail(state, result: ModuleDetail) {
        state.result = result;
    },

    setTranscriptRequest(state, request: TranscriptRequest) {
        state.transcriptRequest = request;
    },

    setConfig(state, config: Config) {
        state.config = config;
    }
}

const actions: ActionTree<GradeState, GradeState> = {
}

const getters: GetterTree<GradeState, GradeState> = {
    config(state) {
        return state.config;
    },

    excurStudy(state, getters) {
        let studyList = getters.studiesByLatestAppraisalDate;
        return studyList.find((study: Study) => study.academicYears.length !== 0 && study.id === state.config.excurid);
    },

    noExcurStudy(state, getters) {
        let studyList = getters.studiesByLatestAppraisalDate;
        return studyList.filter((study: Study) => study.academicYears.length !== 0 && study.id !== state.config.excurid);
    },

    studiesByStudyYear(state): Study[] {
        return state.studies.sort((a, b) => b.lastStudyYear - a.lastStudyYear);
    },

    studiesByLatestAppraisalDate(state): Study[] {
        return state.studies.sort((a, b) => new Date(b.latestAppraisalDate).getTime() - new Date(a.latestAppraisalDate).getTime());
    },

    transcriptRequest(state) {
        return state.transcriptRequest;
    },

    studyListTranscriptRequestable(state,getters): Study[] {
        return getters.studyList.filter((study: Study) => study.isTranscriptRequestable);
    },

    studyList(state, getters): Study[] {
        if (getters.noExcurStudy && getters.excurStudy) {
            return [ ...getters.noExcurStudy, getters.excurStudy];
        }
        return getters.noExcurStudy || [getters.excurStudy] || [];
    }
}

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
    modules: {
        root
    }
})